/**
 * Timeline section scroll animation
 * Creates an animated timeline that fills progressively as user scrolls
 * Highlights timeline points and content blocks based on scroll position
 */

document.addEventListener('DOMContentLoaded', function () {
  const timelineBar = document.querySelector('.timeline-bar');
  const timelineBarFill = document.querySelector('.timeline-bar__fill');
  const points = document.querySelectorAll('.timeline-point');
  const uspBlocks = document.querySelectorAll('.section-timeline__usp > li');

  function updateTimeline() {
    const scrollY = window.scrollY + window.innerHeight / 2;
    let lastFilledIndex = -1;

    uspBlocks.forEach((block, i) => {
      const rect = block.getBoundingClientRect();
      const blockTop = rect.top + window.scrollY;
      if (scrollY > blockTop) {
        points[i].classList.add('filled');
        block.classList.add('usp-filled');
        lastFilledIndex = i;
      } else {
        points[i].classList.remove('filled');
        block.classList.remove('usp-filled');
      }
    });

    // Fill bar up to the last filled point
    if (lastFilledIndex >= 0) {
      const firstPoint = points[0].getBoundingClientRect();
      const lastPoint = points[lastFilledIndex].getBoundingClientRect();
      const barRect = timelineBar.getBoundingClientRect();
      const fillHeight = (lastPoint.top + lastPoint.height / 2) - (barRect.top) ;
      timelineBarFill.style.height = fillHeight + 'px';
    } else {
      timelineBarFill.style.height = '0px';
    }
  }

  window.addEventListener('scroll', updateTimeline);
  updateTimeline();
});